import { render, staticRenderFns } from "./AcrChartAdmin.vue?vue&type=template&id=5dd4932f"
import script from "./AcrChartAdmin.vue?vue&type=script&lang=js"
export * from "./AcrChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports